import HttpClient from '../services/HttpClient';
import { APP_URL, MAESTRAS, USUARIOS, EXTERNAL } from '../constants'

export const getMaestras = () => {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json'
        };
        HttpClient.get(`${APP_URL}${MAESTRAS}`, headers).then(response => {
            resolve(response);
        }).catch(error => {
            if (typeof error.response === 'undefined') {

                reject({ error: 'technical_error', error_description: 'Occurió un problema comuniquese con el administrador.' });
            }
            reject(error.response);
            resolve(error.response);
        });
    });
}

export const createPersonExternal = (body, dispatch) => {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json'
        };
        HttpClient.post(`${APP_URL}${USUARIOS}${EXTERNAL}`, body, headers).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
}